import axios from 'axios';

const serviceRegions = async function(url) {
  try {
    const response = await axios.get(url);
    
      return response.data;
   
  } catch (error) {
    return [];
  }
};

const liabilityInsurances = async function(url) {
  try {
    const response = await axios.get(url);
    
      return response.data;
   
  } catch (error) {
    return [];
  }
};


const search = async function(url) {
  try {
    const response = await axios.get(url);
    
      return response.data;
   
  } catch (error) {
    return [];
  }
};

const siteUrl = async function(url) {
  try {
    const response = await axios.get(url);
    
      return response.data;
   
  } catch (error) {
    return '';
  }
};

export const searchService = {
  serviceRegions,
  liabilityInsurances,
  search,
  siteUrl
};
